// removed by extract-text-webpack-plugin
module.exports = {"o-header":"_1SG9ev78K-DwwolcDVbkWs","a-akzonobelLogo":"_26NAbDoatruRWJaU5Yb9O5","akzoHeader":"_1vZcZx5RFF_yOw3YbYjUKK","flourishHeader":"ws3UypGWeGm9Cy6_ez3Nx"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/Header/style.scss
// module id = 894
// module chunks = 0